import PropTypes from 'prop-types'
import Video from '../../courses/preview/video'
import { useBreakpoint } from '../../../../hooks/breakpoint'

const SkillsCard = (props) => {
  const {
    previewVideo,
    content,
    children
  } = props

  const { mdAndUp } = useBreakpoint()

  return (
    <div
      className='py-8 px-6 bg-white my-3.5 w-full'
      style={{
        borderRadius: '0 24px 24px 24px',
        height: 'auto',
        width: '100%'
      }}>
      <div
        style={previewVideo ? { minHeight: 193 } : mdAndUp ? { maxWidth: 770 } : {}}
        className='flex flex-col md:flex-row w-full'>
        {previewVideo
          ? <Video
            style={{
              paddingBottom: 0,
              marginRight: 24,
              ...!mdAndUp
                ? {
                  width: 150,
                  height: 100,
                  marginBottom: 24
                }
                : {}
            }}
            videoAttrs={{
              style: {
                borderRadius: '0 16px 16px 16px'
              }
            }}
            containerVideoAttrs={
              mdAndUp
                ? {
                  style: {
                    minWidth: 276,
                    minHeight: 193
                  }
                }
                : {}}
            course={{ previewVideo }}
          />
          : null}
        {content}
      </div>
      {children}
    </div>
  )
}

SkillsCard.propTypes = {
  previewVideo: PropTypes.object,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  children: PropTypes.node
}

export default SkillsCard
